module.exports = __webpack_public_path__ + "static/media/title-bg-23.a0352c90.jpg";